export default __webpack_public_path__ + "static/media/Thrive_logo_HOL.f82385c0.png";